import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export function friendlyError(code: string, message: string, requestId?: string): ReactNode {
  const id = requestId ? <span className="muted"> (ID: {requestId})</span> : null;
  switch (code) {
    case 'insufficient_balance':
      return (
        <>
          Saldo tidak cukup untuk request ini. <Link to="/wallet">Isi saldo dulu</Link>, lalu coba lagi.{id}
        </>
      );
    case 'budget_exceeded':
      return (
        <>
          Anggaran proyek atau API key sudah tercapai. Ubah anggarannya di <Link to="/projects">Proyek</Link>.{id}
        </>
      );
    case 'rate_limit_exceeded':
    case 'concurrency_exceeded':
      return <>Terlalu banyak request dalam waktu singkat. Tunggu sebentar lalu coba lagi.{id}</>;
    case 'model_not_found':
    case 'model_not_active':
      return (
        <>
          Model ini sedang tidak tersedia. Pilih model lain di <Link to="/models">daftar model</Link>.{id}
        </>
      );
    case 'model_not_allowed':
      return (
        <>
          API key ini tidak diizinkan memakai model tersebut. Pilih model lain, atau ubah akses model key-nya di{' '}
          <Link to="/api-keys">API Key</Link>.{id}
        </>
      );
    case 'upstream_model_unavailable':
      return (
        <>
          Provider sudah tidak menyediakan model ini. Pilih model lain di <Link to="/models">daftar model</Link>, atau pasang model
          cadangan di <Link to="/projects">Proyek</Link>.{id}
        </>
      );
    case 'unsupported_parameter':
      return <>Model ini tidak mendukung pengaturan tersebut: {message}{id}</>;
    case 'context_length_error':
      return <>Pesan terlalu panjang untuk model ini. Persingkat atau pilih model dengan konteks lebih besar.{id}</>;
    default:
      return (
        <>
          {message}
          {id}
        </>
      );
  }
}
